var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9 0c4.983 0 9 4.017 9 9s-4.017 9-9 9-9-4.017-9-9 4.017-9 9-9zm0 6.75l-1.459 7.541c-.018.105-.044.229-.044.334 0 .835.668 1.503 1.503 1.503.835 0 1.503-.668 1.503-1.503V6.75H9zM13.878 9h2.25A7.127 7.127 0 0 0 9 1.872c-3.876 0-7.04 3.111-7.128 6.961.088-3.226 2.751-5.836 6.003-5.836A6.005 6.005 0 0 1 13.878 9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#8A8888",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#255EBA",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h24v24H-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.48718b24972d504e4797c7daa3fafd9f.svg";
export { ForwardRef as ReactComponent };